export default __webpack_public_path__ + "static/media/vampire.6f43def1.png";